import { BaseUser } from '@app/domain/BaseUser'
import { UserNotificationPreferences } from '@app/domain/UserNotificationPreferences'

export enum UserRole {
    OWNER,
    MANAGER,
    STAFF,
    VIEWER,
}

export class AccountUser extends BaseUser {
    constructor(
        id: string,
        name: string,
        public emailAddress: string,
        public role: UserRole,
        venueIds: string[] | null,
        notificationPreferences: UserNotificationPreferences[],
        pinCode: string | null
    ) {
        super(id, name, venueIds, notificationPreferences, pinCode)
    }

    get isOwner(): boolean {
        return this.role === UserRole.OWNER
    }

    get isManager(): boolean {
        return this.role === UserRole.MANAGER
    }

    get isStaff(): boolean {
        return this.role === UserRole.STAFF
    }

    get isViewer(): boolean {
        return this.role === UserRole.VIEWER
    }

    isAdministrator(): boolean {
        return this.emailAddress.trim().toLowerCase().endsWith('@tablesense.com')
    }

    canEditUser(user: BaseUser): boolean {
        if (this.role === UserRole.OWNER) {
            return true
        }
        return this.id === user.id
    }
}
